import {   Typography, Stack, Divider, } from '@mui/material';

const SectionDivider = ({ label, children }) => {
    return (
      <Stack direction="row" spacing={1} alignItems="center" sx={{ width: '100%', }}>
        <Divider sx={{
          flexGrow: 1,
          '&::before, &::after': {
          borderColor: "#1976d2"
          },
        }}>
          {label &&  <Typography variant="subtitle2" sx={{ color: "#1976d2", fontFamily: "Roboto", px: 1 }}>
            {label? label :""}
          </Typography>}
         
        </Divider>
        {children}
      </Stack>
    );
  };

  export default SectionDivider